import { useSelector } from "react-redux";
import { useTheme } from "styled-components";

import { NotificationsCounter } from "../../UI";

// Icons
import {
  DropDownArrow,
  TruckIcon,
  RoadIcon,
  TowingIcon,
  TireIcon,
  TrailerIcon
} from "../../../SVGS";

// Constants
import * as serviceTypes from "../../../constants/serviceTypes.constants";

import styled from "styled-components";

const DashboardServiceItemStyles = styled.div`
  border-radius: ${({ theme }) => theme.radius[4]};
  padding: ${({ theme }) => theme.spacing[8]} ${({ theme }) => theme.spacing[12]};
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${({ $bgColor }) => $bgColor};
  margin-bottom: ${({ theme }) => theme.spacing[8]};
  cursor: pointer;
  border: ${({ $isNotification, $bgColor, theme }) =>
    $isNotification ? `1px solid ${theme.colors.semantic.outline.default}` : `1px solid ${$bgColor}`};

  &:last-child {
    margin-bottom: 0;
  }

  .serviceType {
    display: flex;
    align-items: center;
    height: 20px;

    .serviceTypeName {
      font-style: normal;
      font-weight: ${({ theme }) => theme.typography.body.b3.weight};
      font-size: ${({ theme }) => theme.typography.body.b3.size};
      line-height: ${({ theme }) => theme.typography.body.b3.lineHeight};
      color: ${({ theme }) => theme.colors.semantic.text.strong};
      margin-left: ${({ theme }) => theme.spacing[4]};
    }
  }

  .ID {
    font-style: normal;
    font-weight: 600;
    font-size: ${({ theme }) => theme.typography.body.b3.size};
    line-height: ${({ theme }) => theme.typography.body.b3.lineHeight};
    color: ${({ theme }) => theme.colors.semantic.text.strong};
    margin-top: ${({ theme }) => theme.spacing[8]};
  }

  .arrowContainer {
    transform: rotate(-270deg);
  }
`;

const DashboardServiceItem = ({
  id,
  serviceTypeKey = serviceTypes.TRUCK_SHOP,
  newMessagesCount,
  status,
  onClick,
  isNotification = false
}) => {
  const { systemComponents } = useSelector(state => state.app);
  const theme = useTheme();
  const serviceType = systemComponents.serviceTypes.find(
    type => type.typeKey === serviceTypeKey
  );
  const generateIcon = () => {
    switch (serviceTypeKey) {
      case serviceTypes.TRUCK_SHOP:
        return <TruckIcon style={{ width: 16, marginRight: 8 }} />;
      case serviceTypes.ROAD_ASSISTANCE:
        return <RoadIcon style={{ width: 16, marginRight: 8 }} />;
      case serviceTypes.TOWING:
        return <TowingIcon style={{ width: 16, marginRight: 8 }} />;
      case serviceTypes.TIRE_REPAIR:
        return <TireIcon style={{ width: 16, marginRight: 8 }} />;
      case serviceTypes.TRAILER_REPAIR:
        return <TrailerIcon style={{ width: 16, marginRight: 8 }} />;

      default:
        return null;
    }
  };

  const bgColor = () => {
    if (isNotification) {
      return "transparent";
    }
    switch (status) {
      case "pending":
        return theme.colors.accent[50];
      case "paused":
        return "#FFF0B3";
      case "in-progress":
        return theme.colors.success[50];
      default:
        return theme.colors.accent[50];
    }
  };
  return (
    <DashboardServiceItemStyles
      onClick={onClick}
      $isNotification={isNotification}
      $bgColor={bgColor()}
    >
      <div>
        <div className="serviceType">
          {generateIcon()}
          <p className="serviceTypeName">{serviceType?.name}</p>
        </div>
        <p className="ID">ID: {id}</p>
      </div>

      {isNotification ? (
        <NotificationsCounter
          className="notificationCounter"
          counter={newMessagesCount}
        />
      ) : (
        <div className="arrowContainer">
          <DropDownArrow />
        </div>
      )}
    </DashboardServiceItemStyles>
  );
};

export default DashboardServiceItem;
